import { CalendarClock, Phone, Mail, CheckCircle2 } from "lucide-react";
import { StatusPill, fmtDate } from "./crmShared";

const daysLate = (d, today) => Math.round((new Date(`${today}T12:00:00`) - new Date(`${d}T12:00:00`)) / 86400000);

export const FollowUpQueue = ({ items, today, onOpen }) => (
  <div data-testid="crm-followups" className="rounded-2xl border border-gray-800 bg-card overflow-hidden">
    <div className="px-5 py-4 border-b border-gray-800 flex items-center gap-2">
      <CalendarClock className="h-4 w-4 text-amber-400" />
      <h2 className="font-display font-semibold text-sm text-white">Follow-up queue</h2>
      <span data-testid="followups-count" className="ml-auto text-xs text-gray-400">{items.length} due today or earlier</span>
    </div>
    {items.length === 0 ? (
      <p data-testid="followups-empty" className="px-5 py-10 text-sm text-gray-500 text-center flex items-center justify-center gap-2"><CheckCircle2 className="h-4 w-4 text-emerald-400" /> You're all caught up.</p>
    ) : (
      <div className="divide-y divide-gray-800/60 max-h-[460px] overflow-y-auto">
        {items.map((p) => {
          const late = daysLate(p.next_follow_up_date, today);
          return (
            <button key={p.id} data-testid={`followup-row-${p.id}`} onClick={() => onOpen(p)} className="w-full text-left px-5 py-3 hover:bg-white/[0.03] transition-colors flex flex-wrap items-center gap-x-4 gap-y-1">
              <div className="min-w-[180px] flex-1">
                <p className="text-sm font-semibold text-white">{p.church_name}</p>
                <p className="text-xs text-gray-400">{p.pastor_name || "—"}{p.city || p.state ? ` · ${[p.city, p.state].filter(Boolean).join(", ")}` : ""}</p>
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-400">
                {p.phone && <span className="flex items-center gap-1"><Phone className="h-3 w-3" />{p.phone}</span>}
                {p.email && <span className="hidden md:flex items-center gap-1"><Mail className="h-3 w-3" />{p.email}</span>}
              </div>
              <StatusPill status={p.status} id={`followup-status-${p.id}`} />
              <span data-testid={`followup-due-${p.id}`} className={"text-xs font-semibold w-28 text-right " + (late > 0 ? "text-red-400" : "text-amber-300")}>
                {late > 0 ? `${late} day${late > 1 ? "s" : ""} overdue` : "Due today"}
                <span className="block text-[10px] font-normal text-gray-500">{fmtDate(p.next_follow_up_date)}</span>
              </span>
            </button>
          );
        })}
      </div>
    )}
  </div>
);
